{
  "title": "Avslutt andelseierskap",
  "description": "Andelseier ønsker å avslutte andelseierskapet, enten fordi alle eiendommene er solgt og andelen ikke skal overdras, eller fordi vedkommende ikke lenger ønsker å være andelseier",
  "summaryDescription": "Sjekk at informasjonen stemmer før du avslutter andelseierskapet"
}
